import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {InformationUnitModel} from './response/information-unit.model';
import {UpdateInformationUnitModel} from '@core/modules/rest/informationunit/request/update-information-unit.model';
import {PreviewUnitWithPopupRequestModel} from '@core/modules/rest/informationunit/request/preview-unit-with-popup-request.model';
import {PreviewUnitWithPopupResponseModel} from '@core/modules/rest/informationunit/response/preview-unit-with-popup-response.model';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {DeleteUnitRequestModel} from '@core/modules/rest/consent/request/delete-unit-request.model';

@Injectable()
export class InformationUnitRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/informationunit';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getInformationUnitById(id: string): Observable<InformationUnitModel> {
        const url = this.controllerUrl.concat('/').concat(id);
        return this.httpClient.get<InformationUnitModel>(url);
    }

    saveInformationUnit(unitUpdateRequest: UpdateInformationUnitModel): Observable<InformationUnitModel> {
        return this.httpClient.put<InformationUnitModel>(this.controllerUrl.concat('/'), unitUpdateRequest);
    }

    previewInformationUnitWithPopUps(request: PreviewUnitWithPopupRequestModel): Observable<PreviewUnitWithPopupResponseModel> {
        return this.httpClient.post<PreviewUnitWithPopupResponseModel>(this.controllerUrl.concat('/preview'), request);
    }

    deleteInformationUnit(request: DeleteUnitRequestModel): Observable<OutlineUnitBasicModel[]> {
        const url = this.controllerUrl.concat('/').concat(request.informationUnitId);
        return this.httpClient.post<OutlineUnitBasicModel[]>(url, request);
    }
}
